import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CCCOFVA_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cccofva/logo.png",
        alt: "Coastal Counseling Center Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 24,
  state: "VA",
  departmentIds: [138],
};
